import { skipToken } from "@tanstack/react-query";
import { useCurrentWorkspaceId } from "@v2/contexts/WorkspaceDashboardContext";
import useCurrentUser from "@v2/hooks/useCurrentUser";
import { workspaceRouter } from "@v2/trpc/routes/workspace";

export function useHasWorkspaceMembership() {
  const { user } = useCurrentUser();
  const workspaceId = useCurrentWorkspaceId();

  const {
    data: workspaceMembershipsData,
    isLoading: workspaceMembershipsIsLoading,
  } = workspaceRouter.getMembers.useQuery(workspaceId ?? skipToken);

  const isUserMemberOfWorkspace =
    workspaceMembershipsData?.workspaceMemberships.some(
      (membership) => membership.user.id === user?.id,
    );

  return {
    isUserMemberOfWorkspace,
    workspaceMembershipsIsLoading,
    workspaceMembershipsData,
  };
}
